import { configLoader } from './configLoader';

export const loadRemoteConfig = async () => {
  await configLoader.loadRemoteConfig();
}; 